import { get as lodashGet } from 'lodash'
import { KV_LIVE_STATS_UNLEASH_FLAG } from '@ahaslides-product/frontend-toolkit'
import { slideType } from '@/constant/allSlideTypes'
import SlideApi from '@/api/slide'
import { CATEGORY_OPTION_LENGTH } from '@/constant/Categorise.constant'
import {
  STATS_TYPES, AGGREGATION_LEVELS,
} from '@/mqtt/liveStats'

const services = {
  updateCategories: async (slideId, categories) => {
    await SlideApi.patchCategoriesBySlideId(slideId, { categories })
  },
  generateCategory: () => ({ id: window.crypto.randomUUID(), value: '', options: [] }),
}

const _getters = {
  categoriseSlides: (_, __, rootState) => {
    const slides = lodashGet(rootState, 'presentation.slides', [])
    return slides.filter((slide) => slide.type === slideType.categorise)
  },
  slideActiveCategories: (_, __, rootState) => {
    const defaultCategories = JSON.stringify([
      services.generateCategory(),
      services.generateCategory(),
    ])
    const categoryRawData = lodashGet(rootState, 'slideActive.matchingQuestionOptions', defaultCategories) || defaultCategories
    const categories = JSON.parse(categoryRawData)
    if (categories.length === 0) {
      return [services.generateCategory(), services.generateCategory()]
    }

    if (categories.length === 1) {
      return [...categories, { ...services.generateCategory() }]
    }
    return categories
  },

}

const actions = {
  async subscribeCategoriseStatsAction({ dispatch, rootGetters }, slide) {
    if (rootGetters[KV_LIVE_STATS_UNLEASH_FLAG]) {
      await dispatch('liveStatsV2/fetchStatsByKeyAction', {
        statsKeys: [
          `${STATS_TYPES.CORRECT_ANSWER_COUNT}/${AGGREGATION_LEVELS.PER_ACTIVITY}/${slide.id}/${slide.version}`,
          `${STATS_TYPES.INCORRECT_ANSWER_COUNT}/${AGGREGATION_LEVELS.PER_ACTIVITY}/${slide.id}/${slide.version}`,
        ],
      }, { root: true })

      await dispatch('liveStatsV2/fetchStatsByWildCardAction', {
        path: `${STATS_TYPES.CORRECT_ANSWER_COUNT}/${AGGREGATION_LEVELS.PER_ANSWER_VALUE}/${slide.id}/${slide.version}`,
      }, { root: true })

      await dispatch('liveStatsV2/fetchStatsByWildCardAction', {
        path: `${STATS_TYPES.INCORRECT_ANSWER_COUNT}/${AGGREGATION_LEVELS.PER_ANSWER_VALUE}/${slide.id}/${slide.version}`,
      }, { root: true })
    } else {
      await dispatch('liveStatsV2/fetchStatsAction', {
        id: slide.id,
        version: slide.version,
      }, { root: true })
    }

    dispatch('liveStatsV2/subscribeStatsAction', {
      identifier: slide.id,
      statsType: STATS_TYPES.CORRECT_ANSWER_COUNT,
      aggregationLevel: AGGREGATION_LEVELS.PER_ACTIVITY,
    }, { root: true })

    dispatch('liveStatsV2/subscribeStatsAction', {
      identifier: slide.id,
      statsType: STATS_TYPES.INCORRECT_ANSWER_COUNT,
      aggregationLevel: AGGREGATION_LEVELS.PER_ACTIVITY,
    }, { root: true })

    dispatch('liveStatsV2/subscribeStatsAction', {
      identifier: slide.id,
      statsType: STATS_TYPES.CORRECT_ANSWER_COUNT,
      aggregationLevel: AGGREGATION_LEVELS.PER_ANSWER_VALUE,
    }, { root: true })

    dispatch('liveStatsV2/subscribeStatsAction', {
      identifier: slide.id,
      statsType: STATS_TYPES.INCORRECT_ANSWER_COUNT,
      aggregationLevel: AGGREGATION_LEVELS.PER_ANSWER_VALUE,
    }, { root: true })
  },

  async updateCategoriesAction({ commit, rootState }, payload) {
    const { slideActive } = rootState
    if (!slideActive) return
    const matchingQuestionOptions = JSON.stringify(payload)
    const nonEmptyCategories = payload.filter((category) => category && category.value && category.value.trim())
    if (nonEmptyCategories && nonEmptyCategories.length > 0) {
      nonEmptyCategories.forEach((category) => {
        category.options = category.options.filter(
          (option) => option.value && option.value.trim().length <= CATEGORY_OPTION_LENGTH,
        )
      })
    }
    commit('updateSlideActive', { matchingQuestionOptions }, { root: true })
    await services.updateCategories(slideActive.id, nonEmptyCategories)
  },
}

const mutations = {

}

const categorise = {
  namespaced: true,
  getters: _getters,
  actions,
  mutations,
}

export default categorise
